import User from './UserIcon.vue';
import Flag from './FlagIcon.vue';
import Github from './GithubIcon.vue';

export default {
  user: User,
  flag: Flag,
  github: Github,
};
